export const appConsts = {
    regExEmailValidation: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    regEverythingButDigits: /\D/g,
    verificationCodeBoxes: [0, 1, 2, 3, 4, 5],
}

export const TERMS_VERSION = "2019-06-04.01"
export const MARKETING_SITE = "https://www.shoutbase.com"
export const TERMS_OF_SERVICE_URL = `${MARKETING_SITE}/terms-of-service`
export const PRIVACY_POLICY_URL = `${MARKETING_SITE}/privacy-policy`
export const TUTORIAL_URL = `${MARKETING_SITE}/tutorials`
export const PUSH_REPORT_TO_ZAPIER = `${MARKETING_SITE}/blog/push-report-to-zapier/`
// todo: change this url
export const GOOGLE_CALENDAR_INTEGRATION_URL = `${MARKETING_SITE}/tutorials`
export const ZOOM_INTEGRATION_URL = `${MARKETING_SITE}/tutorials`

// pricing
export const PRICE_USER_PER_MONTH = 9
export const PRICE_USER_PER_YEAR = 90
export const PRICE_INDIVIDUAL = 0
export const DESKTOP_LINK = `${MARKETING_SITE}/desktop-app`

export const tutorialSteps = {
    items: {
        1: {
            step: 1,
            title: "Create time records",
            subtitle:
                "Organize your time by creating and editing time records, starting and stopping timers, and using tags.",
        },
        2: {
            step: 2,
            title: "Create a team",
            subtitle:
                "Keep track of your organization's time records by creating a new team and adding members.",
        },
        3: {
            step: 3,
            title: "Team management",
            subtitle:
                "As a team administrator, view your team's time records sorted by team member, project, or date range.",
        },
        4: {
            step: 4,
            title: "Tags and goals",
            subtitle:
                "Create and edit tags and goals to organize your time records and track your progress.",
        },
        5: {
            step: 5,
            title: "Get reports",
            subtitle:
                "View and export reports for your projects, team members, or your entire team.",
        },
        done: {
            step: "done",
            title: "Tutorial Complete",
            subtitle:
                "You can access the help videos any time from the main system menu in the upper right corner of the screen.",
        },
    },
    videoId: "6SWfM_PVTGw",
    playList: "cAhRhTLMLfw,VbhmK9amoz4,BgsY3ghyVe4,AlYeDJvZdLQ",
    sort: [1, 2, 3, 4, 5, "done"],
}



// WEBPACK FOOTER //
// ./src/common/constants/app_consts.js